export function getCanEditListingProfilePhotos({ isPreview, listingData }) {
  return Boolean(!isPreview && listingData?.permissions?.can_edit)
}
